/**
 * List of team
 * @enum {string}
 */
export var Team;

(function (Team) {
  Team["Checkout"] = "Checkout";
  Team["Growth"] = "Growth";
  Team["Presentation"] = "Presentation";
  Team["OrderManagement"] = "OrderManagement";
  Team["Payment"] = "Payment";
  Team["Acquisition"] = "Acquisition";
  Team["Framework"] = "Framework";
  Team["Backend"] = "Backend";
  Team["SellingTools"] = "SellingTools";
})(Team || (Team = {}));